import axios from 'axios'

const API_URL = '/frontend/'

// Get single order
const getOrder = async (token, order_id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + order_id
  const response = await axios.get(url, config)
  return response.data
}

const getMeistarklases = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + "meistarklases"
  const response = await axios.get(url, config)
  return response.data
}

const exportOrders = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  }
  const url = API_URL + "export"
  const response = await axios.post(url, data, config)
  return response.data
}

const getZurnaliGramatas = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + "products/494,495"
  const response = await axios.get(url, config)
  return response.data
}

const getMeistarklaseApmekletaji = async (token, selected_date) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + "pasutijumi-meistarklases"
  const response = await axios.post(url, selected_date, config)
  return response.data
}

const sendCoupons = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + "send-coupons"
  const response = await axios.post(url, data, config)
  return response.data
}

// Get cash orders
const getCashOrders = async (token, page) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'cash?page=' + page
  const response = await axios.get(url, config)
  console.log(response)
  return response
}

// Get invoice orders
const getInvoiceOrders = async (token, page) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'invoice?page=' + page
  const response = await axios.get(url, config)
  return response
}

// Get invoice orders
const getOrders = async (token, page) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = API_URL + 'skipped?page=' + page
  const response = await axios.get(url, config)

  return response.data
}

const importMultipleFromNumber = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = '/api/multiple-number'
  const response = await axios.post(url, data, config)
  return response.data
}

const getMeistarklaseCoupons = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const url = '/api/meistarklase-coupons'
  const response = await axios.get(url, config)
  return response.data
}

const getAllProducts = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'products'
  const response = await axios.get(url, config)
  return response.data
}

const getGramatuPiegadeCoupon = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'gramatu-piegade'
  const response = await axios.get(url, config)
  return response.data
}

const getGramatuPiegadeExpiryDates = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'gramatu-piegade-datubaze'
  const response = await axios.get(url, config)
  return response.data
}

const postGramatuPiegadeExpiryDates = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const url = API_URL + 'gramatu-piegade'
  const response = await axios.post(url, data, config)
  return response.data
}

const orderService = {
  getOrder,
  getCashOrders,
  getInvoiceOrders,
  getOrders,
  getMeistarklases,
  getMeistarklaseApmekletaji,
  getZurnaliGramatas,
  sendCoupons,
  exportOrders,
  importMultipleFromNumber,
  getMeistarklaseCoupons,
  getAllProducts,
  getGramatuPiegadeCoupon,
  getGramatuPiegadeExpiryDates,
  postGramatuPiegadeExpiryDates
}

export default orderService